import { useQuery } from '@tanstack/react-query';
import { getAgentById, getAgentsByQuery } from '../requests/agent';

const KEY = 'agent';

const agentQuery = {
  useGetAgentById: (data = {}, headers = {}) => useQuery({
    queryKey: [KEY, data],
    queryFn: () => getAgentById(data, headers),
    enabled: !!data.id,
    cacheTime: 0,
    staleTime: 0,
  }),
  useGetAgentsByQuery: (data = { query: {} }) => useQuery({
    queryKey: [KEY, data],
    queryFn: () => getAgentsByQuery(data),
    cacheTime: 0,
    staleTime: 0,
  }),
};
export default agentQuery;
